const ja = {
    9000001: "2023 クリスマス",
    9000002: "カップ - スーパーエックス・フューチャーズ",
    9000003: "トレーディング・コンペティション、賞金30,000USDTが当たる",
    9000004: "参加者数",
    9000005: "アンロック・ジャックポット（USDT）",
    9000006: "先物取引高ランキング予選会",
    9000007: "先物利回りランキング ",
    9000008: " プロフィットランキング予選",
    9000009: `最大 <span style="color: #ffc72b;">20,000</span> USDTのボーナスプールをアンロックする先物取引高ランキング大会 `,
    9000010: "参加者数に応じて賞金総額が増え、最大20,000USDTとなる。 ",
    9000011: "ジャックポット金額",
    9000012: "開催期間中、毎日10:00（UTC）に更新",
    9000013: "賞金見積もり ",
    9000014: "先物総取引高",
    9000015: "表彰規定 ",
    9000016: "参加者数に応じて賞金総額が増え、最大20,000USDTとなる。 ",
    9000017: "ジャックポット金額（USDT）",
    9000018: "活動収益率ランキング",
    9000019: "サインアップ",
    9000020: "活動の利益額ランキング",
    9000021: "終了",
    9000022: `先物利回りランキングコンテスト、賞金 <span style="color: #ffc72b;">{moneyPond}</span> USDT`,
    9000023: `利益ランキング大会、<span style="color: #ffc72b;">{moneyPond}</span> USDTボーナス`,
    9000024: "グロス先物利回り",
    9000025: "先物利益総額",
    9000026: "開始していません",
    9000027: "上位50名の参加者にはボーナス報酬が与えられます。ボーナス報酬を得るには、取引ランキング報酬ルールをご参照ください。",
    9000028: "先物利回りの上位50名の参加者には報酬が与えられます。報酬を得るには、取引ランキング報酬規則を参照してください。",
    9000029: "アクティビティ取引量ランキング",
    9000030: "登録に成功しました",
    9000031: "アプリをダウンロードする",
    9000032: "戻る首页",

    //合约交易积分
    9100001: 'ポイントを貯める',
    9100002: '空中投下を受ける',
    9100003: 'インセンティブ',
    9100004: 'ポイント残高',
    9100005: '詳細',
    9100006: 'チェックインポイント',
    9100007: '取引ポイント',
    9100008: 'ゆうどうせきぶん',
    9100009: 'ボーナスポイント',
    9100010: 'ラッキーくじ',
    9100011: 'ポイントの取得',
    9100012: 'せきぶんそく',
    9100013: '積分明細',
    9100014: 'このイベントに参加するには応募が必要で、クリックすれば参加できます',
    9100015: '{day}日連続取引を行い、{num}ポイントを獲得した',
    9100016: '今日得た {num} ポイント',
    9100017: 'せきぶんプール',
    9100018: '抽選ごとに {point} ポイントを消費し、1日最大 {num} 回引く',
    9100019: '本日の抽選回数',
    9100020: 'ユーザー',
    9100021: 'せきぶん',
    9100022: 'ポイント残高不足',
    9100023: 'ポイント残高が不足しておりますので、ポイントを取得してから抽選にご参加ください',
    9100024: '抽選回数が上限に達しました',
    9100025: '今日の抽選回数は上限に達しましたので、明日もう一度試してください。',
    9100026: 'ポイントの獲得方法',
    9100027: 'サインアップして契約取引ポイント獲得アクティビティに参加し、ポイントを獲得してください。',
    9100028: '参加申し込み成功',
    9100029: '契約取引に応募してポイントを獲得して、取引に行ってもっとポイントを獲得しましょう（コミッション還元奨励を受けなくなります）',
    9100030: '申し込みをキャンセルすると、ポイントはもらえなくなりますが、本当にキャンセルしますか。',
    9100031: '取引ポイント活動センター',
    9100032: 'ポイントの取得',
    9100033: 'このイベントに参加するには応募が必要で、クリックすれば参加できます',
    9100034: '契約に連続して参加することでポイントを得ることができます',
    9100035: 'ユーザーが契約市場で発生したすべての取引行為がポイントを取得することができます',
    9100036: 'ランキングポイント',
    9100037: '毎日の取引ランキング上位5位にボーナスポイントが追加される',
    9100038: '招待された人はポイントを生成し、招待者は奨励ポイントを得ることができる',
    9100039: '{guy} 当選済み<span style="color:#D9A31A"> {num} ポイント</span>',
    9100040: '今すぐくじを引く',
    9100041: 'ご獲得おめでとうございます',
    9100042: 'すべてのタイプ',
    9100043: 'このページにとどまります',
    9100044: '登録に参加する',
    9100045: '取引を続ける',
    9100046: '継続的な活動はありませんので、しばらくお待ちください...',
    9100047: 'SCS トークンを引き換える',
    9100048: '',
    9100049: '',

    9100050: '時間',
    9100051: 'スタート時間',
    9100052: '終了時間',
    9100053: 'に/まで',
    9100054: 'タイプ',

    9100055: '獲得ポイント = 取引量 * 1% (プラットフォームの総取引量が増加するにつれて、難易度はさらに調整されます)',
    9100056: '例: ユーザーは 100USDT*100X=10000U のマージンを持つポジションを使用します。',
    9100057: '100ポイントを獲得するには100USDTのデポジットのみが必要です',
    9100058: 'プラットフォームトークンSCSを入手するには取引ポイントが唯一の方法です',
    9100059: '追加ボーナスポイント＝当日の合計ポイント×ランキング報酬率',
    9100060: 'ランキング',
    9100061: '1位',
    9100062: '2位',
    9100063: '3位',
    9100064: '4位',
    9100065: '5位',
    9100066: '招待された人はポイントを生成し、招待者は奨励ポイントを得ることができる',
    9100067: '勾配係数',
    9100068: '計算式：獲得昇格ポイント＝招待者が獲得するポイント×レベル係数',
    9100069: 'レベル係数は実際の状況に応じて調整されます',
    9100070: '例: ユーザー B がポイント アクティビティに参加し、その招待者はユーザー A で、ユーザー A からの招待数はレベル 3 に達し、ユーザー B はポイント = 360,000 を蓄積しています。',
    9100071: 'ユーザー A が獲得できる累積プロモーション ポイント = 360000*30% = 108,000',
    9100072: 'インセンティブ係数',
    9100073: '取引ユーザー1名',
    9100074: 'トランザクション量が500Wに達する',
    9100075: 'トランザクション量が2000Wに達する',

    9100076: '出入金',

    //热币
    9100080: 'イベントは終了しました',
    9100081: '「サインアップ」をクリックして賞品を獲得しましょう',
    9100082: 'ルールの表示',
    9100083: '参加を申し込む',
    9100084: 'イベント',
    9100088: '貿易',
    9100089: 'デポジット',
    9100090: 'イベントに既に申し込み済みです。',

    9100091: 'このイベントは終了しました。次のイベントにご期待ください。',
    9100092: 'イベントはまだ始まっていませんので、お待ちください。',
    9100093: '',
    9100094: '',

    //api key
    9100105: 'APIキーの作成',
    9100106: 'APIドキュメントの確認',
    9100107: '統合トレーディングシステム',
    9100108: 'APIキーの作成/管理',
    9100109: 'APIのデプロイ',
    9100110: '取引とリクエスト',
    9100111: '先導的なデジタル資産取引プラットフォーム',
    9100112: '豊富なデジタル資産取引および資産管理サービスを提供し、多様な取引ニーズに応えます。',
    9100113: 'より良いサービスの提供',
    9100114: 'より優れた取引手数料、より高い取引額、より柔軟なアカウント管理機能などを提供します。',
    9100115: '数百万のユーザーに信頼されています',
    9100116: '安全な取引環境を確保し、専門的なカスタマーサポートを提供し、デジタル資産の世界で着実に前進するお手伝いをします。',
    9100117: 'SuperExでAPIキーを作成する方法は？',
    9100118: 'SuperExのAPIドキュメントはどこで見ることができますか？',
    9100119: 'SuperExで取引に問題が発生した場合はどうすればよいですか？',
    9100120: 'SuperExのAPIを使用する方法は？',
    9100121: 'SuperEx APIに接続し、取引をより迅速かつスムーズに行います',
    9100122: 'ログイン状態でアバター上にマウスを置き、「API管理」をクリックし、「APIキーの作成」をクリックして、SuperExで自分のAPIキーを作成します。注：ログインしていない場合は、まずSuperExのアカウントにログインする必要があります。 また、画面下部の「APIs」ナビゲーションバーから入り、SuperExで自分のAPIキーを作成することもできます。',
    9100123: '<a style="color:#d1a53e;text-decoration:underline !important;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;" href="https://docs-api.superex.com">APIドキュメント</a>をクリックして、SuperExのAPIドキュメントを確認できます',
    9100124: '使用中に問題がある場合や提案がある場合は、以下の方法でお問い合わせいただけます： <br>公式ウェブサイトの「ヘルプセンター」を利用するか、support@superex.com にメールを送ってカスタマーサービスに連絡してください。',
    9100125: `SuperExのAPIを使用するには、以下の手順が必要です：<br>
SuperExアカウントに登録し、ログインします。<br>
APIキーを作成すると、access_keyとsecret_keyが生成されます。<br>
このaccess_keyとsecret_keyを使用してリクエストに署名します。<br>
必要に応じて、SuperExが提供するさまざまなAPIを使用できます。例えば、市場データAPI、取引API、アカウントAPIなどがあります。各リクエストはAPIドキュメントの指示に従い、適切なHTTPヘッダと署名が必要で`,
    9100126: 'APIキー管理',
    9100127: '新しいAPIキーの作成',
    9100128: '備考名',
    9100129: '備考名を入力してください',
    9100130: '権限設定（複数選択可能）',
    9100131: '読み取り',
    9100132: '取引',
    9100133: 'IPアドレスの紐付け（任意）',
    9100134: '複数のIPアドレスは英語のコンマで区切り、最大10個まで入力可能',
    9100135: '私は読んで同意しました',
    9100136: 'APIユーザーリスク通知に同意しました',
    9100137: '作成',
    9100138: 'SuperExは強力なAPIを提供しています。このAPIを通じて、市場情報の照会や自動取引などのサービスを利用できます。<a style="color:#0052D9;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;text-decoration:underline !important;color:#d1a53e;" href="https://docs-api.superex.com">APIドキュメント</a>で使用方法を確認してください。',
    9100139: 'ユーザーは最大で10組のAPIキーを作成できます',
    9100140: 'Pアドレスが紐付けられていないAPIキーは、90日後に自動的に無効になります。長期間使用する場合は、以下の「私のAPIキー — 操作 — 更新」からAPIキーの有効期限を90日延長することができます。IPアドレスが紐付けられているAPIキーには有効期限がありません。',
    9100141: '私のAPIキー',
    9100142: '権限',
    9100143: 'IPアドレスの紐付け',
    9100144: '更新',
    9100145: 'APIキーを作成するためには、スポットウォレットに任意の金額を入金してアカウントを有効化する必要があります',
    9100146: '現在のAPIキーの更新を確認してください',
    9100147: 'Access KeyおよびSecret Keyを漏洩しないでください。それにより資産損失が生じる可能性があります。',
    9100148: 'セキュリティ上の理由から、APIキーにIPアドレスをバインドすることをお勧めします。各APIキーには最大10個のIPアドレスをバインドできます。単一のIPアドレスを直接入力し、複数のIPアドレスはカンマで区切ってください。例：192.168.1.1,192.168.1.2',
    9100149: '更新に成功すると有効期限が再計算されます。APIキーを長期間使用する場合は、IPアドレスを紐付けすることをお勧めします。紐付けられたAPIキーは有効期限がなく、さらに安全です。',
    9100150: '現在のAPIキーを削除しますか？',
    9100151: '次のリスクを理解する必要があります：',
    9100152: 'APIキーはあなたのアカウントの安全性と密接に関連しています。あなたのAPIキーを知っている第三者はあなたのアカウント資産を制御する可能性がありますので、APIキーを適切に保管し、第三者には公開せず、第三者のウェブサイトやフォーラムにアップロードしないでください。',
    9100153: 'あなたの個人的な理由でAPIキーが漏れた場合、資産の安全問題、経済的損失問題などを含むすべての責任はあなたが負担します。私たちはこれに対して責任を負いません。',
    9100154: 'リスクの通知',
    9100155: '私はリスクを認識し、自発的に受け入れる意思があることを知らせます。',
    9100156: '保存しました',
    9100157: '権限設定',
    9100158: 'キーは一度だけ表示され、失われた後は回復できません。必ず安全に保管してください。',
    9100159: 'Access KeyおよびSecret Keyを漏洩しないでください。それにより資産損失が生じる可能性があります。',
    9100160: 'Secret Keyを忘れた場合は、そのキーペアを削除して新しいキーペアを申請してください。',
    9100161: '強力なAPIを提供し、取引機能をアプリケーションに効率的に統合するお手伝いをします。APIはアカウント、取引、市場データの3種類に分けられ、ニーズに応じて適切な権限を設定し、APIを通じて自動取引を実現できます。',
    9100162: '作成日時',
    9100163: '新しいAPIキーの作成',
    9100164: '編集',
    9100165: '有効期限',
    9100166: '削除する',
    9100167: '作成が成功しました。',
    9100168: 'ヒント',
    9100169: 'わかった',
    9100170: 'API ユーザーのリスクに関する警告',
    9100171: 'IPアドレスの形式が正しくありません',
    9100172: '',
    //自由区二维码分享页面
    91000951: '自由区上場、富の自由を開始',
    91000961: 'アプリを開く',
    //自由区二维码分享页面
    9100095: '自由区上場、富の自由を開始',
    9100096: 'アプリを開く',
    9100097: '',
    9100098: '',
}
export default ja



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/ja.js